/**
 * Roles based Layout
 */
const roleLayout = {
  admin: 'backoffice',
  staff: 'backoffice',
  sales: 'backoffice',
  supplier: 'portal',
  customer: 'portal',
  'inventory lookup': 'inventoryLookup',
  onlyGuest: [],
};

export default roleLayout;
